import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=df33e230&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/components/problemDetails/problemDetail.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./detail.vue?vue&type=style&index=2&id=df33e230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df33e230",
  null
  
)

export default component.exports